
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/user","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M10 1.042a4.792 4.792 0 11-4.792 4.792A4.8 4.8 0 0110 1.042zm0 8.333a3.542 3.542 0 10-3.542-3.541A3.546 3.546 0 0010 9.375z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M17.159 18.958a.625.625 0 01-.625-.625c0-2.872-2.931-5.208-6.534-5.208s-6.533 2.336-6.533 5.208a.625.625 0 01-.625.625.625.625 0 01-.625-.625 5.926 5.926 0 012.328-4.608A8.631 8.631 0 0110 11.875a8.631 8.631 0 015.455 1.85 5.926 5.926 0 012.328 4.611.625.625 0 01-.624.622z","opacity":".4"}})])])
          )
        }
      }
    